import React, { useContext } from 'react';
import Layout from '../layout/Layout';
import { Routes } from 'react-router-dom';
import { useB2BRoute } from './hoc/B2BRoute';
import { LoginContext } from '../../App';

const B2BRoutesModule = ({ routes }) => {
    const { sidebarOpen, selectedItem } = useContext(LoginContext);

    return (
        <Layout sidebarOpen={sidebarOpen} selectedItem={selectedItem}>
            <Routes>
                {useB2BRoute(routes)}
            </Routes>
        </Layout>
    );
};

export default B2BRoutesModule;